import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import { uploadFileViaSignedUrl } from "@/lib/upload";

// Three-step upload (MDF-specific endpoints). Sub-bucket 4 hoisted the
// in-line coordination into a shared helper; sub-bucket 15 relocated it to
// `@/lib/upload` and renamed to `uploadFileViaSignedUrl`. This hook stays a
// thin MDF-side wrapper that wires endpoint config + cache invalidation.
//
// Failure semantics unchanged from the original bucket 9 port — see
// `lib/upload.ts` for the contract.

export function useUploadMdfAttachment(requestId: string) {
  const queryClient = useQueryClient();
  return useMutation<{ id: string }, ApiClientError, File>({
    mutationFn: (file) =>
      uploadFileViaSignedUrl(file, {
        initEndpoint: "/portal/mdf/attachments/upload-init",
        finalizeEndpoint: "/portal/mdf/attachments",
        buildFinalizeBody: ({ storageKey, file }) => ({
          request_id: requestId,
          storage_key: storageKey,
          file_name: file.name,
          content_type: file.type || "application/octet-stream",
          size_bytes: file.size,
        }),
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.mdf.draft(requestId),
      });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to upload attachment");
    },
  });
}
